// import external modules
import { combineReducers } from "redux";

import { reducer as toastrReducer } from "react-redux-toastr";
import customizer from "./customizer/";
import { reducer as ReducerForm } from "redux-form";
import auth from "./authentication/auth";
import planning from "./planning/planning";
import annees from "./annees/annees";
import cours from "./cours/cours";
import emargements from "./emargements/emargements";
import classes from "./classes/classes";

const rootReducer = combineReducers({
  toastr: toastrReducer, // <- Mounted at toastr.
  customizer: customizer,
  form: ReducerForm,
  auth,
  plannings: planning,
  annees,
  cours,
  emargements,
  classes,
});

export default rootReducer;
